import * as Rx from 'rxjs/Rx'
import { Action, Store } from 'redux'
import { ActionsObservable, combineEpics } from 'redux-observable'

import Dependencies from '../Dependencies'
import Epic from '../Epic'
import State from '../../states'
import { MediaInput } from '../../actions'
import { MoveEventHelper } from '../../io/events'
import { Player } from '../../states/WorldState'

// Upload photo
export const uploadPhoto = (
  action$: ActionsObservable<Action>,
  store: Store<State>,
  { logger, apiClient, appContext }: Dependencies
) =>
  action$
    .filter(MediaInput.uploadPhoto.started.match)
    .switchMap(({ payload }) => {
      const { photo, note } = payload

      logger.info('Uploading photo, note=', note)
      const state = store.getState()

      // TODO: extract this repeating shit
      const player = state.world.mapObjects[state.world.player!.id]
        .mapObject as Player
      let position = player.position!
      const { lastMoveEvent } = player
      if (lastMoveEvent) {
        const helper = new MoveEventHelper({
          id: '',
          mapObjectID: player.id,
          type: 'move',
          local: true,
          bySelf: false,
          ...lastMoveEvent
        })
        const now = new Date().getTime()
        const elasped = now - lastMoveEvent.createdAt
        position = helper.currentPosition(elasped)
      }
      const legacyPosition = appContext.clientSession!.legacyCRS.wanderToLegacy(
        position
      )
      return apiClient
        .postPhoto({
          userID: state.login.user!.id,
          position: legacyPosition,
          photo,
          note
        })
        .map(() =>
          MediaInput.uploadPhoto.done({
            params: payload,
            // TODO:
            result: {}
          })
        )
        .catch((error: Rx.AjaxError) => {
          logger.error('Fail to upload photo, error=', error)
          return Rx.Observable.of(
            MediaInput.uploadPhoto.failed({
              params: payload,
              error
            })
          )
        })
    })

export default combineEpics<Epic>(uploadPhoto)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/epics/operations/uploadPhoto.ts